<template>
  <div id="website">
    <div class="logo">
      <img :src="logoImg" alt="" />
    </div>
    <nav-menu v-if="!isFromWechat" @click="handleClick"></nav-menu>
    <popup :visiable="visiable" @close="closeDrawer"></popup>
    <div class="top">
      <img src="../../assets/china/map.png" alt="地图" />
    </div>
    <div id="top-img">
      <swiper class="address-swiper" :options="swiperOption">
        <swiper-slide>
          <div class="swiper-item-wrapper">
            <div class="address-item">
              <i class="iconfont icon-position positioning-icon" />
              <div>
                <h3 class="address-item-title">BEIJING</h3>
                <h3 class="address-item-title">英特波科技(北京)有限公司</h3>
                <!-- <p class="address-item-desc">
                  北京市朝阳区建国路93号院1号楼1808室
                </p> -->
                <p class="address-item-desc">
                  北京市朝阳区光华路4号东方梅地亚中心C座2801
                </p>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="address-item">
            <i class="iconfont icon-position positioning-icon" />
            <div>
              <h3 class="address-item-title">SHENZHEN</h3>
              <h3 class="address-item-title">英特波科技(深圳)有限公司</h3>
              <p class="address-item-desc">
                深圳市南山区粤海街道大冲社区深南大道9668号华润置地大厦C座2708
              </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="address-item">
            <i class="iconfont icon-position positioning-icon" />
            <div>
              <h3 class="address-item-title">SHANGHAI</h3>
              <h3 class="address-item-title">上海办公室</h3>
              <p class="address-item-desc">
                上海市长宁区古北路666号嘉麒大厦22楼01室
              </p>
              <p class="address-item-desc">
                上海市长宁区凯旋路1398号3号楼1005室
              </p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="address-item">
            <i class="iconfont icon-position positioning-icon" />
            <div>
              <h3 class="address-item-title">CHENGDU</h3>
              <h3 class="address-item-title">成都办公室</h3>
              <p class="address-item-desc">
                成都市锦江区红星路三段1号国际金融中心IFS 1号办公楼30楼02号
              </p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="china-introduce">
      <p>
        2008年新加坡INDIBA Asia亚洲分公司成立，
        伴随人们美丽与健康意识的增长，INDIBA以其出色的效果、卓越的体验，在韩国、日本、中国香港、中国台湾地区受到了消费者与社会各界的一致褒奖。
      </p>
      <p>
        同时，越来越多的中国消费者了解到INDIBA产品科技，为了更好的服务中国市场，2016年3月，英特波（北京）科技有限公司正式注册成立。
      </p>
      <p>
        七年间，INDIBA陆续于深圳、上海、成都设立办事处，累计销售设备超过2000台、帮助1500家健康美容机构为其客户提供INDIBA设备带来的卓越服务、培训和认证INDIBA操作师5862（持续增长中）人、每年，超过12000+名中国消费者因为INDIBA的突破性的技术与专业服务恢复自然健康美丽。
      </p>
      <p>
        为了更好的保护中国消费者的切身权利，INDIBA（英特波）中国积极探索防伪以及产品溯源系统，致力保护INDIBA合作伙伴利益及消费者权益，共同抵御假冒产品造成消费者权益受损。
      </p>
      <p>
        未来，INDIBA（英特波）将继续以科技之力，深耕中国消费者服务，成为更多更好价值的提供者。
      </p>
    </div>
    <div class="staff-bottom">
      <swiper class="staff-swiper" ref="swiper" :options="swiperOption_2">
        <swiper-slide v-for="(item, index) in chinaStaff" :key="index">
          <div class="china-staff-content">
            <div class="header-top">
              <div class="img-name">{{ item.name }}</div>
              <div class="img-enName">{{ item.enName }}</div>
            </div>
            <img
              :src="require(`../../assets/home/chinaperson/${item.imgId}.jpg`)"
              alt=""
            />
            <div class="img-bottom">
              <div class="img-contry">{{ item.attributeproperty }}</div>
              <div class="img-address">{{ item.compony }}</div>
            </div>
          </div>
        </swiper-slide>
        <!-- <swiper-slide>Resize me 2</swiper-slide>
        <swiper-slide>Resize me 3</swiper-slide>
        <swiper-slide>Resize me 4</swiper-slide>
        <swiper-slide>Resize me 5</swiper-slide>
        <swiper-slide>Resize me 6</swiper-slide> -->
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
      <div class="swiperBtn">
        <div slot="button-prev">
          <img
            class="pre"
            src="../../assets/china/arrow_new.png"
            @click="handlePrev"
            alt="pre"
          />
        </div>
        <span>{{ `${currentPage}/${Math.ceil(chinaStaff.length)}` }}</span>
        <div slot="button-next">
          <img
            src="../../assets/china/arrow_new.png"
            @click="handleNext"
            alt="next"
            class="next"
          />
        </div>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
let vm;
import NavMenu from "./components/NavMenu.vue";
import Popup from "./components/Popup.vue";
import areaList from "../pc/config/areaList";
import axios from "axios";
import "vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { chinaStaff } from "../../const/index";

export default {
  name: "Founds",
  components: {
    Popup,
    NavMenu,
    swiper,
    swiperSlide,
  },
  created() {
    vm = this;
    document.title = "找到INDIBA";
    const queryObj = this.$route.query;
    if (queryObj && queryObj.formWechat) {
      // console.log("isFromwechat", this.isFromWechat);
      this.isFromWechat = true;
    }
  },
  mounted() {
    document
      .getElementById("myvideo")
      .setAttribute("controlslist", "nodownload");
    axios
      .get(`/api/Company/GetMyPageList?rows=800&page=${this.currentPage}`)
      .then(function (res) {
        // vm.totalNum = res.data.data.total;
        //   vm.storeList = res.data.data.rows;
        let tempList = res.data.data.rows;
        tempList.forEach((item) => {
          item.provinceName = "";
          item.cityName = "";
          item.countryName = "";
          for (let i in areaList.province_list) {
            if (item.F_ProvinceId === i) {
              item.provinceName = areaList.province_list[i] || "";
            }
          }
          for (let i in areaList.city_list) {
            if (item.F_CityId === i) {
              item.cityName = areaList.city_list[i] || "";
            }
          }
          for (let i in areaList.county_list) {
            if (item.F_CountyId === i) {
              item.countryName = areaList.county_list[i] || "";
            }
          }
        });
        vm.storeList = tempList;
      })
      .catch(function (err) {
        this.$message.error(err);
      });
  },
  data() {
    return {
      visiable: false,
      logoImg: require("../../assets/home/logo.png"),
      showArea: false,
      btnTitle: "点我选择省市区",
      areaList,
      chinaStaff,
      Searchvalue: "",
      currentPage: 1,
      isFromWechat: false,
      //   totalNum: 0,
      storeList: [],
      swiperOption: {
        slidesPerView: 1.3,
      },
      getPopupContainers: (triggerNode) => triggerNode.parentNode,
      storeName: "",
      swiperOption_2: {
        slidesPerView: 2,
        spaceBetween: 30,
        direction: "horizontal",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          resize: () => {
            this.$refs.swiper.$swiper.changeDirection(
              window.innerWidth <= 960 ? "vertical" : "horizontal"
            );
          },
        },
      },
    };
  },
  filters: {
    capitalize: function (value) {
      //   return value.slice(0, 14);
      return value;
    },
  },
  watch: {},
  methods: {
    // handleNavMap(){

    // },
    // 上一个人
    handleNext() {
      this.$refs.swiper.swiper.slideNext();
      if (this.currentPage < chinaStaff.length) {
        this.currentPage++;
      }
      // this.currentPage =this.currentPage + 1;
    },
    handlePrev() {
      this.$refs.swiper.swiper.slidePrev();
      if (this.currentPage > 1) {
        this.currentPage--;
      }
      // this.currentPage--;
    },
    handleMapNav(F_Longitude, F_Latitude, F_Address, F_FullName) {
      const params = { F_Longitude, F_Latitude, F_Address, F_FullName };
      // console.log("params",params)
      this.$router.push({
        path: "/map",
        query: params,
      });
    },
    handleClick() {
      this.visiable = true;
    },
    closeDrawer() {
      this.visiable = false;
    },
    onConfirm(values) {
      console.log("val:", values);
      this.btnTitle = values.filter((item) => !!item).map((item) => item.name);
      // .join("       ");
      // if(values[1].code){
      //     this.btnTitle = values
      // .filter((item) => !!item)
      // .map((item) => item.name)
      // .join("  ");
      // }
      if (this.btnTitle[0] && this.btnTitle[1] && this.btnTitle[2]) {
        this.btnTitle = this.btnTitle.join("     ");
      } else if (this.btnTitle[0] && this.btnTitle[1] && !this.btnTitle[2]) {
        this.btnTitle = this.btnTitle[0] + "     " + this.btnTitle[1];
      } else if (this.btnTitle[0] && !this.btnTitle[1] && !this.btnTitle[2]) {
        this.btnTitle = this.btnTitle[0];
      } else {
        this.btnTitle = "点我选择省市区";
      }
      console.dir(this.btnTitle);
      //   axios
      //     .get(
      //       `/api/Company/GetMyPageList?rows=1000&provinceId=${values[0]?.code}&cityId=${values[1]?.code}&countyId=${values[2]?.code}&page=${this.currentPage}`
      //     )
      //     .then(function (res) {
      //       //   vm.storeList = res.data.data.rows;
      //       let tempList = res.data.data.rows;
      //       tempList.forEach((item) => {
      //         item.provinceName = "";
      //         item.cityName = "";
      //         item.countryName = "";
      //         for (let i in areaList.province_list) {
      //           if (item.F_ProvinceId === i) {
      //             item.provinceName = areaList.province_list[i] || "";
      //           }
      //         }
      //         for (let i in areaList.city_list) {
      //           if (item.F_CityId === i) {
      //             item.cityName = areaList.city_list[i] || "";
      //           }
      //         }
      //         for (let i in areaList.county_list) {
      //           if (item.F_CountyId === i) {
      //             item.countryName = areaList.county_list[i] || "";
      //           }
      //         }
      //       });
      //       vm.storeList = tempList;
      //     })
      //     .catch(function (err) {
      //       console.log(err);
      //     });
      this.showArea = false;
    },
    onchange() {
      axios
        .get(
          `/api/Company/GetMyPageList?rows=1000&page=${this.currentPage}&companyName=${this.Searchvalue}`
        )
        .then(function (res) {
          // vm.totalNum = res.data.data.total;
          //   vm.storeList = res.data.data.rows;
          let tempList = res.data.data.rows;
          tempList.forEach((item) => {
            item.provinceName = "";
            item.cityName = "";
            item.countryName = "";
            for (let i in areaList.province_list) {
              if (item.F_ProvinceId === i) {
                item.provinceName = areaList.province_list[i] || "";
              }
            }
            for (let i in areaList.city_list) {
              if (item.F_CityId === i) {
                item.cityName = areaList.city_list[i] || "";
              }
            }
            for (let i in areaList.county_list) {
              if (item.F_CountyId === i) {
                item.countryName = areaList.county_list[i] || "";
              }
            }
          });
          vm.storeList = tempList;
        })
        .catch(function (err) {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
#website {
  background-color: #001a70;
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  color: #fff;
  .logo {
    width: 200px;
    height: 34px;
    left: 1.5rem;
    top: 1.8rem;
    z-index: 1;
    position: absolute;
  }
  .top {
    width: 100vw;
    padding: 12px;
    margin-top: 60px;
  }
  #top-img {
    width: 100vw;
    height: 300px;
    background-image: url(../../assets/img/bgc2.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    .address-swiper {
      .address-item {
        margin-top: 120px;
        background: rgba(0, 0, 0, 0.2);
        height: 120px;
        color: #f0f0f0 !important;
        padding: 0 0.8rem;
        margin-right: 0.8rem;
        margin-left: 0.8rem;
        border-radius: 10px;
        display: flex;
        align-items: center;
        .positioning-icon {
          margin-right: 0.3rem;
        }
        .address-item-title {
          font-size: 0.9rem;
          font-weight: 500;
          color: #f0f0f0 !important;
          height: 1rem;
          line-height: 1.125rem;
        }
        .address-item-desc {
          font-size: 0.4rem;
          color: rgba(0, 0, 0, 0.65);
          line-height: 1rem;
          color: #f0f0f0 !important;
        }
        .address-item-desc:first-child {
          margin-top: 0.8rem;
        }
      }
    }
  }
  .staff-bottom {
    margin: 12px;
    /* width: 90vw; */
    margin: 0 auto;
    /* background: white; */
    padding: 12px;
  }
  .staff-swiper {
    .header-top {
      text-align: center;
      padding: 6px;
    }
    .img-bottom {
      text-align: center;
      padding: 8px;
    }
    .img-name {
      font-size: 23px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    img {
      width: 42vw;
      height: auto;
      object-fit: contain;
    }
  }
  .swiperBtn {
    display: flex;
    justify-content: space-around;
    width: 80%;
    margin: 0 auto;
    height: 36px;
    align-items: center;
    margin-top: 16px;
    background: #fff;
    border-radius: 16px;
    div {
      width: 16px;
      height: 16px;
    }
    img {
      width: 100%;
      height: 100%;
    }
    span {
      color: black;
      font-weight: 600;
    }
    .pre {
      transform: rotate(-90deg);
    }
    .next {
      transform: rotate(90deg);
    }
  }
  .china-introduce {
    background: #fff;
    color: black;
    padding: 30px;
  }
  .choose-btn {
    text-align: center;
    padding: 0.5rem 0;
    margin: 1rem;
    border: 1px solid #fff;
    background-color: transparent;
    border-radius: 5px;
    font-size: 0.8rem;
    color: #fff;
  }
  .search-wrapper {
    margin: 0 1rem;
    background-color: #001a70;
    .van-search__content {
      color: #fff !important;
      padding-left: 0;
      border-bottom: 1px solid #999;
      background-color: #001a70;
      //   input.van-field__control::-webkit-input-placeholder{
      //     color: #fff!important;
      //   }
    }
    .van-search__content /deep/.van-field__control {
      color: #fff !important;
    }
  }
  .item-wrapper {
    margin: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item-logo {
      width: 5rem;
      height: 5rem;
      background-color: #fff;
      display: flex;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      img {
        width: 90%;
        max-height: 100%;
      }
    }
    .item-descrption {
      width: 14rem;
      margin: 0;
      margin-left: 1rem;
      padding: 0.5rem;
      font-size: 0.7rem;
      background-color: #6b8ac8;
      border-radius: 5px;
      h3 {
        font-size: 0.9rem !important;
        color: #fff;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      p {
        margin-top: 0.1rem;
        margin-bottom: 0.1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        a {
          color: #fff;
        }
      }
      .icon-name {
        display: flex;
        justify-content: space-between;
      }
      p {
        width: 10rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .item-icon {
      //   font-size: 1rem;
      margin-right: 0.2rem;
    }
    .icon-des {
      display: flex;
      border-left: 1px solid #fff;
      width: 2rem;
      justify-content: space-around;
      align-items: flex-end;
      flex-direction: column;
    }
  }
  .footer {
    background: #fff;
    height: 26px;
    width: 100vw;
  }
}
</style>
